import { Outlet, NavLink } from 'react-router-dom'
import { useAuthStore } from '../../hooks/useAuth'
import { useState, Suspense } from 'react'
import {
  LayoutDashboard, TrendingUp, FileText, DollarSign,
  FolderOpen, UserCircle, LogOut, Menu, X, Landmark
} from 'lucide-react'
import clsx from 'clsx'
import { fecLarga } from '../../lib/dateUtils'

function ContentLoader() {
  return (
    <div className="flex-1 flex items-center justify-center py-24">
      <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-500 rounded-full animate-spin" />
    </div>
  )
}

const navItems = [
  { label: 'Dashboard',    to: '/accionista',            icon: LayoutDashboard, end: true },
  { label: 'Mis Acciones', to: '/accionista/acciones',   icon: TrendingUp },
  { label: 'Informes',     to: '/accionista/informes',   icon: FileText },
  { label: 'Dividendos',   to: '/accionista/dividendos', icon: DollarSign },
  { label: 'Préstamos',    to: '/accionista/prestamos',  icon: Landmark },
  { label: 'Documentos',   to: '/accionista/documentos', icon: FolderOpen },
  { label: 'Mi Perfil',    to: '/accionista/perfil',     icon: UserCircle },
]

export default function AccionistaLayout() {
  const { user, logout } = useAuthStore()
  const [open, setOpen] = useState(false)

  return (
    <div className="flex min-h-screen bg-gray-50">
      <aside className={clsx(
        'fixed inset-y-0 left-0 z-50 w-60 bg-indigo-800 flex flex-col transition-transform duration-250 lg:translate-x-0',
        open ? 'translate-x-0' : '-translate-x-full'
      )}>
        <div className="px-5 py-5 border-b border-white/15">
          <img src="/logo-aqua.png" alt="Aqua" className="h-10 w-auto brightness-0 invert" />
          <div className="text-xs font-bold uppercase tracking-widest text-white/40 mt-0.5">Portal Accionistas</div>
        </div>

        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
          {navItems.map(({ label, to, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => clsx(
                'flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-semibold transition-all',
                isActive ? 'bg-white/20 text-white' : 'text-white/65 hover:bg-white/10 hover:text-white'
              )}
              onClick={() => setOpen(false)}>
              <Icon size={17} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/15">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white/20 border-2 border-white/30 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              {user?.avatar}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold text-white truncate">{user?.nombre}</div>
              <div className="text-xs text-white/40 font-semibold">Accionista</div>
            </div>
            <button onClick={logout} className="text-white/50 hover:text-white transition-colors p-1">
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </aside>

      {open && <div className="fixed inset-0 z-40 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}

      <main className="flex-1 lg:ml-60 flex flex-col min-h-screen">
        <header className="h-14 bg-white border-b border-gray-100 flex items-center px-5 sticky top-0 z-30">
          <button className="lg:hidden p-2 rounded-lg hover:bg-gray-100 mr-3" onClick={() => setOpen(true)}>
            <Menu size={20} className="text-gray-600" />
          </button>
          <span className="text-sm font-semibold text-gray-500">
            {fecLarga(new Date())}
          </span>
        </header>
        <div className="flex-1 p-5 md:p-6">
          <Suspense fallback={<ContentLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </div>
  )
}
